module.exports = __webpack_public_path__ + "images/ce00be3dc63f1e8251a40bd492bd32a5.png";